// Saved email subject/body pairs -- DocuSign's "message template". One module for every caller
// (both creator modals and the builder's Edit Message dialog) so the fetch and save shapes stay
// in step with MessageTemplatesController, which is the only server side of this.
//
// Reads never throw: the picker is an optional convenience sitting inside a form the user is
// already filling in, so a failed load has to degrade to "no saved messages" rather than take
// the surrounding dialog down with it. Writes do throw -- the user asked for that one, and
// silently dropping it would look like it saved.
const ENDPOINT = '/settings/message_templates.json'

function csrfToken () {
  return document.querySelector('meta[name=csrf-token]')?.content
}

export async function loadMessageTemplates () {
  try {
    const resp = await fetch(ENDPOINT, { headers: { Accept: 'application/json' } })

    if (!resp.ok) return []

    return (await resp.json()).message_templates || []
  } catch {
    return []
  }
}

export async function saveMessageTemplate ({ name, subject, body }) {
  const resp = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken()
    },
    body: JSON.stringify({ message_template: { name, subject, body } })
  })

  const data = await resp.json().catch(() => ({}))

  if (!resp.ok) throw new Error(data.error || 'Could not save this message template.')

  return data.message_template
}
